
@if (showCameraPopUp) {
  <kx-camera-audio-permssion [device]="device" [resource]="resourceName"
  (closedevicePopup)="closedevicePopup($event)"></kx-camera-audio-permssion>
}
<div id="reader"></div>

@if (checkMobile()) {
  <img src="assets/images/telemedicine/switch-Camera.svg" class="cursor-pointer center-btn" alt="Press to Switch Camera"
    (click)="switchCamera()">
}
<div class="input-prepend input-group d-flex justify-content-center mt-3">
  <button [routerLink]="['']" class="primary-btn" type="button">
    <i class="fa fa-arrow-left"></i>&nbsp;Go to Home
  </button>
</div>